import { ITypesenseWaitListWithRef } from '../typesense/typesense-wait-list';
import { type ICandidate } from './candidate';

export interface IWaitListCandidate {
  candidate: ICandidate;
  appointment: ITypesenseWaitListWithRef;
  productivity: number;
}
